import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/downloads/components/DownloadsSkeleton.tsx");
